"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _lodash = require("lodash");
var _react = require("react");
var _useRespondToTimezoneChange = _interopRequireDefault(require("./useRespondToTimezoneChange"));
var _useDateRespondToTimezoneChange = require("./useDateRespondToTimezoneChange");
var _TimezoneContext = require("../_contexts/TimezoneContext");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
/**
 * This hook should be used when we want a week/range picker to maintain the same
 * calendar start and end days when the timezone changes.
 * To do this we convert the interval's start and end day to be the
 * start of day and end of day respectively, in the newly selected timezone.
 * This hook needs to be used at the highest level where we employ the timezone
 * context, because if the parent component re-renders we will be getting the
 * same value for the timezone ref used under the hood.
 * This is why this hook is not included in the DatePickerWeekPrevNext component directly:
 * one would need to change the outside week/interval, and just send in a new `week`/`interval` prop
 * to the picker.
 *
 * @param {function} setInterval - a use state setter, that will set the new
 * interval = an object with start / end js dates; it needs to be from
 * `useState` because it uses the previous state to do the calculation.
 * @param {function} callback - an additional callback we want to call after setting
 * the interval. Will receive as argument the new interval value. Should be
 * memoized.
 */
var useIntervalRespondToTimezoneChange = function useIntervalRespondToTimezoneChange(setInterval, callback) {
  var _useTimezone = (0, _TimezoneContext.useTimezone)(),
    timezone = _useTimezone.timezone,
    localTimezone = _useTimezone.localTimezone;
  var setIntervalCallback = (0, _react.useCallback)(function () {
    return setInterval(function (interval) {
      // if the state was null it will stay null
      if ((0, _lodash.isEmpty)(interval)) {
        return null;
      }
      // get the new interval
      var newIntervalStartJsDate = (0, _useDateRespondToTimezoneChange.convertToStartEndOfDayInNewTimezone)({
        date: interval.startDate,
        isEndOfDay: false,
        localTimezone: localTimezone,
        timezone: timezone
      });
      var newIntervalEndJsDate = (0, _useDateRespondToTimezoneChange.convertToStartEndOfDayInNewTimezone)({
        date: interval.endDate,
        isEndOfDay: true,
        localTimezone: localTimezone,
        timezone: timezone
      });
      callback === null || callback === void 0 ? void 0 : callback(newIntervalStartJsDate, newIntervalEndJsDate);
      // set the internal state
      return {
        startDate: newIntervalStartJsDate,
        endDate: newIntervalEndJsDate
      };
    });
  }, [callback, localTimezone, setInterval, timezone]);
  (0, _useRespondToTimezoneChange["default"])(setIntervalCallback);
};
var _default = useIntervalRespondToTimezoneChange;
exports["default"] = _default;